import React, { useCallback, useMemo } from "react";
import { Switch, Typography } from "@mui/material";

import {
  FormattingRule,
  FormattingRuleType,
  createFormattingRule,
  getFormattingRule,
  deleteFormattingInstructionValues,
} from "@coolset/cs-ui";

export const TableFormattingInputs: React.FC<TableFormattingInputsProps> = ({ onChange, formattingInstructions }) => {
  const rowAsHeaderRule = useMemo<FormattingRule | undefined>(
    () =>
      getFormattingRule(formattingInstructions, {
        ruleType: FormattingRuleType.Row,
        position: "1",
        isHeader: true,
      }),
    [formattingInstructions]
  );

  const columnAsHeaderRule = useMemo<FormattingRule | undefined>(
    () =>
      getFormattingRule(formattingInstructions, {
        ruleType: FormattingRuleType.Column,
        position: "A",
        isHeader: true,
      }),
    [formattingInstructions]
  );

  const handleToggleHeaderRule = useCallback(
    (ruleType: FormattingRuleType) => {
      let rule = ruleType === FormattingRuleType.Row ? rowAsHeaderRule : columnAsHeaderRule;

      if (!rule) {
        const [newRules] = createFormattingRule(formattingInstructions, {
          ruleType,
          position: ruleType === FormattingRuleType.Row ? "1" : "A",
          isHeader: true,
        });
        onChange(newRules);
      } else {
        const [newRules] = deleteFormattingInstructionValues(formattingInstructions, rule, ["isHeader"]);
        onChange(newRules);
      }
    },
    [formattingInstructions, rowAsHeaderRule, columnAsHeaderRule, onChange]
  );

  return (
    <>
      <div className="_d-flex-ali-center-jc-sb-sm-gap">
        <Typography variant="h4" color="text.secondary">
          First row contains headers
        </Typography>
        <Switch checked={!!rowAsHeaderRule} onChange={() => handleToggleHeaderRule(FormattingRuleType.Row)} />
      </div>
      <div className="_d-flex-ali-center-jc-sb-sm-gap">
        <Typography variant="h4" color="text.secondary">
          First column contains headers
        </Typography>
        <Switch checked={!!columnAsHeaderRule} onChange={() => handleToggleHeaderRule(FormattingRuleType.Column)} />
      </div>
    </>
  );
};

interface TableFormattingInputsProps {
  formattingInstructions: FormattingRule[];
  onChange: (rules: FormattingRule[]) => void;
}
